// @avantia common-code
import { ensureDefined } from '@avantia/client-and-server-utilities';
import { HpClaimSubmittedAction } from '../actions/submitClaimAction';
import { ClaimConfirmationPageProps } from '../components/claimConfirmationPage';
import { ReducerProcessor } from '../engineClient/reducers/reducerProcessor';
import { HpAction } from '../engineClient/types';
import { HpClaimsActionTypes } from '../types/actionTypes';
import { HpClaimEnquiryResultState } from '../types/stateTypes';
import { getInitialState } from './initialState';

const processor = new ReducerProcessor<HpClaimEnquiryResultState, HpClaimsActionTypes>('ClaimEnquiryResult');

processor.add<HpClaimSubmittedAction>('CLAIM_SUBMITTED', (state, action) => {
  const payload = action.payload as ClaimConfirmationPageProps;
  ensureDefined(payload, 'payload');
  return { ...payload };
});

export function claimEnquiryResultReducer(
  state: HpClaimEnquiryResultState = getInitialState().claimEnquiryResult,
  action: HpAction<unknown>
): HpClaimEnquiryResultState {
  return processor.process(state, action);
}
